import React, { useState, useEffect } from 'react'
import moment from 'moment'

import { Chart } from 'primereact/chart'
import 'chartjs-adapter-moment'

export default function Graph(props) {
	
	const { data, minDatetime, maxDatetime } = props
	const [dataset, setDataset] = useState([])
	
	useEffect(() => {
		if (data) {
			const _series = data.datasets[0].data
			setDataset({datasets:[{data: [..._series, {x: maxDatetime, y: _series[_series.length-1].y}]}]})
		}
	}, [data, maxDatetime])
	
	const options = {
		scales: {
			x: {
				type: 'time',
				suggestedMin: minDatetime,
				ticks: {
					source: 'data',
					callback: (value, index, ticks) => {
						return props.mini ? null : index === 0 ? moment(value).format('DD.MM HH:mm') : index === ticks.length-1 ? '' : null
					},
				},
			},
			y: {
				beginAtZero: true,
				bounds: 'data',
				ticks: {
					source: 'data',
					callback: (value, index, ticks) => {
						return props.mini ? null : index === ticks.length-1 ? value : null
					},
				},
			},
		},
		elements: {
			point: {
				radius: props.mini ? 0 : 4,
				hitRadius: props.mini ? 0 : 3,
				pointStyle: (e) => e.dataIndex === data.datasets[0].data.length ? false : 'circle',
				borderColor: '#f88',
				backgroundColor: '#faa',
			},
			line: {
				stepped: true,
				fill: props.mini ? false : true,
				borderColor: '#f88',
				backgroundColor: props.mini ? '#f88' : '#faa8',
				borderWidth: props.mini ? 1 : 2,
			},
		},
		plugins: {
			legend: {
				display: false,
			},
			tooltip: props.mini ? null : {
				displayColors: false,
				callbacks: {
					label: (context) => {
						return context.dataset.data[context.dataIndex].y
					},
					title: (context) => {
						return context[0].dataset.data[context[0].dataIndex].x.format('DD.MM HH:mm')
					},
				},
			},
		},
		animation: false,
		maintainAspectRatio: false,
	}
	
	return <Chart type="line" data={dataset} options={options}/>
		
}

